import cn from './TriStateToggle.module.scss'

interface Props {
  label: string
  value: boolean | null
  onChange: (v: boolean | null) => void
}

function TriStateToggle({ label, value, onChange }: Props) {
  const cycle = () => {
    if (value === null) onChange(true)
    else if (value === true) onChange(false)
    else onChange(null)
  }
  return (
    <button
      className={[
        cn.triToggle,
        value === true ? cn.triToggleTrue : '',
        value === false ? cn.triToggleFalse : '',
      ]
        .filter(Boolean)
        .join(' ')}
      onClick={cycle}
      type="button"
    >
      {label}
      <span className={cn.triToggleValue}>
        {value === null ? '—' : value ? 'Да' : 'Нет'}
      </span>
    </button>
  )
}

export default TriStateToggle
